"use strict";

var ReviewsBdc = require("modules/product-reviews/product-reviews-bdc");
var ReviewsBca = require("modules/product-reviews/product-reviews-bca");
var ReviewsThd = require("modules/product-reviews/product-reviews-thd");
var globals = require("globals");

module.exports = function (productId, aliasId) {
  switch (globals.siteId) {
    case 2:
      return new ReviewsBca(productId, aliasId);
    case 11:
      return new ReviewsThd(productId, aliasId);
    default:
      return new ReviewsBdc(productId, aliasId);
  }
};